import ErrorReducer from '@common/components/error-component/reducer';

export default { error: ErrorReducer };
